import rootReducer from "./reducers";
import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";

let devTools = window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();
if (process.env.NODE_ENV === 'prod' || process.env.NODE_ENV === 'production') {
    devTools = a => a;
}

export function configureStore() {
	const store = createStore(rootReducer,
		compose(applyMiddleware(thunk), devTools)
	);

	return store;
}


// WEBPACK FOOTER //
// ./src/store/index.js